import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { ReviewPeriod } from "./reviewPeriod"
import { IReviewPeriod } from "./reviewPeriod.types"
import { safeDayjs } from "@/helpers/dateHelper"
import { AccountUnderReviewPeriod } from "@/api/backofficeRest/generated/model"
export type DirectDebitStatusTypes = "Active"

export type PaymentMethodTypes = "Active"

export type IReviewPeriodRaw = AccountUnderReviewPeriod

export const ReviewPeriodParser: IParser<IReviewPeriod, IReviewPeriodRaw> = {
  toDomain: (data: IReviewPeriodRaw) => {
    try {
      return new ReviewPeriod(
        data.id,
        data.createdBy,
        dayjs(data.createdDttm),
        dayjs(data.fromDttm),
        data.reason,
        data.propertySuppressionFl,
        data.suppressBillingFl,
        data.suppressDunningFl,
        data.suppressPaymentCollectionFl,
        data.suppressPaymentReviewFl,
        data.description ?? undefined,
        safeDayjs(data.toDttm),
        safeDayjs(data.cancelledDttm),
        data.cancelledBy ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
